// src/components/Dashboard/DashboardSidebarAdmin.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LogoutButton from "../LogoutButton.jsx";
import { supabase } from "../../supabaseClient.js";


/* ================= SVG ICON COMPONENTS ================= */

const IconDashboard = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <path
      d="M3 11L12 3l9 8v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1v-9z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconProvider = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <path
      d="M5 12h14M12 5v14"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2" />
  </svg>
);

const IconSidebarItems = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <path
      d="M5 6h14M5 12h10M5 18h6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconSettings = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <circle cx="12" cy="12" r="3" strokeWidth="2" />
    <path
      d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconTopupProvider = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <circle cx="12" cy="12" r="10" strokeWidth="2" />
    <path
      d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 18V6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconCredit = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <rect x="3" y="5" width="18" height="14" rx="2" ry="2" strokeWidth="2" />
    <path d="M3 10h18" strokeWidth="2" />
    <path d="M8 15h3" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconAffiliate = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <circle cx="7" cy="8" r="3" strokeWidth="2" />
    <circle cx="17" cy="8" r="3" strokeWidth="2" />
    <path
      d="M4 19v-1a4 4 0 0 1 4-4h0a4 4 0 0 1 4 4v1M12 19v-1a4 4 0 0 1 4-4h0a4 4 0 0 1 4 4v1"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconTransactions = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <rect x="4" y="4" width="16" height="16" rx="2" ry="2" strokeWidth="2" />
    <path
      d="M8 9h8M8 13h5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconRevenue = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <path
      d="M4 19h16M7 15l3-4 3 3 4-6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M15 8h3V5" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconUsers = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <circle cx="9" cy="8" r="3" strokeWidth="2" />
    <path
      d="M4 18v-1a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v1"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="17" cy="8" r="2" strokeWidth="2" />
    <path d="M16 14a3 3 0 0 1 3 3v1" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// 👉 ICON: MODEL AI
const IconModels = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <path
      d="M12 3l4 2.3v4.4l-4 2.3-4-2.3V5.3L12 3z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12.7v4.4L12 19.4l4-2.3v-4.4M4 7.5v9l8 4.6 8-4.6v-9L12 2.9 4 7.5z"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconBlog = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <path d="M12 20h9" strokeWidth="2" strokeLinecap="round" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconActivity = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ================= MENU CONFIG (STATIC, TANPA MODEL AI) ================= */

const staticAdminMenu = [
  {
    key: "admin-dashboard",
    label: "Dashboard",
    path: "/dashboardadmin",
    icon: <IconDashboard />,
  },
  {
    key: "admin-activity",
    label: "User Activity",
    path: "/dashboardadmin/activity",
    icon: <IconActivity />,
  },
  {
    key: "admin-features",
    label: "Setting Tools",
    path: "/dashboardadmin/features",
    icon: <IconSettings />,
  },
  {
    key: "admin-credit-packages",
    label: "Setting Paket",
    path: "/dashboardadmin/packages",
    icon: <IconCredit />,
  },
  {
    key: "admin-providers",
    label: "Topup Provider",
    path: "/dashboardadmin/providers",
    icon: <IconTopupProvider />,
  },
  {
    key: "admin-affiliate",
    label: "Affiliate & Komisi",
    path: "/dashboardadmin/affiliate",
    icon: <IconAffiliate />,
  },
  {
    key: "admin-transactions",
    label: "Transaksi",
    path: "/dashboardadmin/transactions",
    icon: <IconTransactions />,
  },
  {
    key: "admin-revenue",
    label: "Revenue Ledger",
    path: "/dashboardadmin/revenue",
    icon: <IconRevenue />,
  },
  {
    key: "admin-users",
    label: "Pengguna",
    path: "/dashboardadmin/users",
    icon: <IconUsers />,
  },
  {
    key: "admin-blog",
    label: "Management Blog",
    path: "/dashboardadmin/blog",
    icon: <IconBlog />,
  },
];

const DashboardSidebarAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  // ======== state untuk dropdown Model AI ========
  const [features, setFeatures] = useState([]);
  const [loadingFeatures, setLoadingFeatures] = useState(true);
  const [featuresError, setFeaturesError] = useState("");
  const [openModelDropdown, setOpenModelDropdown] = useState(true);

  // Badge state
  const [pendingWithdrawalCount, setPendingWithdrawalCount] = useState(0);

  const handleNavigate = (path) => {
    if (!path) return;
    navigate(path);
    setIsOpen(false);
  };

  // toggle sidebar di mobile
  useEffect(() => {
    const handler = () => setIsOpen((prev) => !prev);
    window.addEventListener("toggle-dashboard-sidebar", handler);
    return () => window.removeEventListener("toggle-dashboard-sidebar", handler);
  }, []);

  // ambil daftar fitur dari tabel `app_features`
  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        setLoadingFeatures(true);
        setFeaturesError("");
        // Gunakan tabel app_features yang benar
        const { data, error } = await supabase
          .from("app_features")
          .select("slug, name") // slug, not code
          .eq("is_active", true)
          .order("sort_order", { ascending: true });

        if (error) throw error;
        setFeatures(data || []);
      } catch (err) {
        console.error("Error fetching features for admin sidebar:", err);
        setFeatures([]);
        setFeaturesError("Gagal memuat daftar fitur.");
      } finally {
        setLoadingFeatures(false);
      }
    };

    fetchFeatures();

    // Fetch pending withdrawals count
    const fetchPendingCount = async () => {
      try {
        const { count, error } = await supabase
          .from("affiliate_withdrawals")
          .select("*", { count: "exact", head: true })
          .eq("status", "pending");

        if (!error) {
          setPendingWithdrawalCount(count || 0);
        }
      } catch (err) {
        console.error("Error fetching pending count:", err);
      }
    };
    fetchPendingCount();

    // Subscribe to changes? Optional, but good for realtime. For now just fetch once on mount.
  }, []);

  // Auto-scroll to active item
  const activeItemRef = useRef(null);
  useEffect(() => {
    if (activeItemRef.current && openModelDropdown) {
      // "di bawah aja" -> block: 'end' aligns it to the bottom
      setTimeout(() => {
        activeItemRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
      }, 100);
    }
  }, [location.pathname, openModelDropdown, loadingFeatures]);

  const modelBasePath = "/dashboardadmin/models";
  const isModelGroupActive = location.pathname.startsWith(modelBasePath);

  return (
    <>
      {/* Backdrop mobile */}
      <div
        className={`fixed inset-0 z-40 bg-slate-900/30 transition-opacity duration-200 md:hidden ${isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
          }`}
        onClick={() => setIsOpen(false)}
      />

      {/* Sidebar */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-50
          w-full md:w-64
          bg-gradient-to-b from-sky-50 via-white to-slate-50
          border-r border-slate-200/80
          flex flex-col min-h-0
          transform transition-transform duration-200
          md:static md:translate-x-0 md:h-screen
          ${isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}
        `}
      >
        {/* Header logo */}
        <div className="h-16 flex items-center justify-between px-6 border-b border-slate-200/80 flex-shrink-0">
          <div className="flex flex-col leading-tight">
            <span className="text-2xl font-extrabold text-sky-600 tracking-tight">
              Neo AI Admin
            </span>
            <span className="text-[10px] font-medium tracking-[0.15em] text-slate-400 uppercase">
              Configuration
            </span>
          </div>

          <button
            type="button"
            className="md:hidden p-1.5 rounded-full hover:bg-slate-100 text-slate-500"
            onClick={() => setIsOpen(false)}
            aria-label="Tutup menu"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path
                d="M6 18L18 6M6 6l12 12"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Menu list */}
        <nav className="flex-1 min-h-0 px-3 py-4 space-y-1 overflow-y-auto">
          {/* Menu statis */}
          {staticAdminMenu.map((item) => {
            const path = item.path || "/dashboardadmin";
            const isActive = location.pathname === path;
            const labelText = item.label || item.key || path || "Menu";

            return (
              <button
                key={item.key || path}
                type="button"
                onClick={() => handleNavigate(path)}
                className={`
                  w-full flex items-center gap-3
                  px-3 py-2.5
                  rounded-xl
                  text-xs sm:text-sm font-medium
                  transition-all
                  ${isActive
                    ? "bg-sky-100/90 text-sky-800 border border-sky-200 shadow-sm"
                    : "text-slate-700 hover:bg-slate-100/90 border border-transparent"
                  }
                `}
              >
                <div
                  className={`
                    w-7 h-7 rounded-lg flex items-center justify-center
                    text-[14px] flex-shrink-0
                    ${isActive
                      ? "bg-sky-500 text-white"
                      : "bg-sky-50 text-sky-600 border border-sky-100"
                    }
                  `}
                >
                  {item.icon}
                </div>

                <div className="min-w-0 flex-1 text-left flex items-center justify-between">
                  <span
                    className="block text-[11px] sm:text-xs leading-snug truncate"
                    title={labelText}
                  >
                    {labelText}
                  </span>
                  {item.key === "admin-affiliate" && pendingWithdrawalCount > 0 && (
                    <span className="flex items-center justify-center min-w-[18px] h-[18px] px-1 bg-rose-500 text-white text-[9px] font-bold rounded-full">
                      {pendingWithdrawalCount}
                    </span>
                  )}
                </div>
              </button>
            );
          })}

          {/* ======== DROPDOWN MODEL AI (DINAMIS DARI TABEL features) ======== */}
          <div className="mt-2">
            {/* Header grup Model AI */}
            <button
              type="button"
              onClick={() => setOpenModelDropdown((prev) => !prev)}
              className={`
                w-full flex items-center gap-3
                px-3 py-2.5
                rounded-xl
                text-xs sm:text-sm font-medium
                transition-all
                ${isModelGroupActive
                  ? "bg-sky-100/90 text-sky-800 border border-sky-200 shadow-sm"
                  : "text-slate-700 hover:bg-slate-100/90 border border-transparent"
                }
              `}
            >
              <div
                className={`
                  w-7 h-7 rounded-lg flex items-center justify-center
                  text-[14px] flex-shrink-0
                  ${isModelGroupActive
                    ? "bg-sky-500 text-white"
                    : "bg-sky-50 text-sky-600 border border-sky-100"
                  }
                `}
              >
                <IconModels />
              </div>

              <div className="min-w-0 flex-1 text-left">
                <span
                  className="block text-[11px] sm:text-xs leading-snug"
                  title="Model Tools"
                >
                  Model Tools
                </span>
              </div>

              {/* panah buka/tutup */}
              <svg
                className={`w-3 h-3 flex-shrink-0 transition-transform ${openModelDropdown ? "rotate-90" : ""
                  }`}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  d="M9 6l6 6-6 6"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {/* Isi dropdown */}
            <div
              className={`
                mt-1 ml-9 pr-1 space-y-0.5
                overflow-hidden transition-all
                ${openModelDropdown ? "max-h-[300vh] opacity-100" : "max-h-0 opacity-0 pointer-events-none"}
              `}
            >
              {loadingFeatures && (
                <p className="text-[10px] text-slate-400 px-1 py-1">
                  Memuat daftar fitur...
                </p>
              )}

              {featuresError && !loadingFeatures && (
                <p className="text-[10px] text-rose-500 px-1 py-1">
                  {featuresError}
                </p>
              )}

              {!loadingFeatures &&
                !featuresError &&
                features.map((f) => {
                  const path = `${modelBasePath}/${f.slug}`;
                  const isActive = location.pathname === path;

                  const label = f.name || f.slug || "Model";

                  return (
                    <button
                      ref={isActive ? activeItemRef : null}
                      key={f.slug}
                      type="button"
                      onClick={() => handleNavigate(path)}
                      className={`
                        w-full text-left text-[10px] sm:text-xs
                        px-2 py-1.5 rounded-lg
                        border
                        ${isActive
                          ? "bg-sky-600 text-white border-sky-600 shadow-sm"
                          : "bg-white/70 text-slate-700 border-slate-200 hover:bg-slate-50"
                        }
                      `}
                    >
                      {label}
                    </button>
                  );
                })}
            </div>
          </div>
        </nav>

        {/* Footer + Logout */}
        <div className="flex-shrink-0 border-t border-slate-200/80 px-3 py-3 bg-white/80 backdrop-blur">
          <LogoutButton className="w-full justify-center" />
        </div>
      </aside >
    </>
  );
};

export default DashboardSidebarAdmin;
